export default "__VITE_PUBLIC_ASSET__7def3e7b__"